import { createFileRoute } from '@tanstack/react-router';

import { JoinScreen } from '../../features/join/JoinScreen';
import { PublicLayout } from '../../layouts/PublicLayout';

/**
 * Spec 12.2 `/:lang/j/:code — guest join`. Real-time: none. A socket is opened only once
 * the player reaches the board.
 */
export const Route = createFileRoute('/$lang/j/$code')({ component: JoinRoute });

function JoinRoute(): React.ReactNode {
  const { lang, code } = Route.useParams();

  return (
    <PublicLayout lang={lang}>
      <JoinScreen code={code} lang={lang} />
    </PublicLayout>
  );
}
